var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 14,
    height: 14,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_2919_5518",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_2919_5518",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAADOUlEQVR4AeVXA6wkQRCdf/atBmfbxs5M9nK2bdv2XXC2g7Pj5Gzbtm2br7I12fnzbU1Sg9fdVa9LvSvE6cvpVEeIoroyxgi4XNoGl0u9HwOG1VaQ95CfkL/ed/esaCPgcFSsAKNLILchn/i9VcIJAV2yrOeA8RuQz3B/pei2nwiGn9LuIacoD0RRzxON5VchP4z+QwhqZ8zocdE7yrFjdFfCdchVyF7ID0kqJ0d3DhRBI1oG41slSaseZYYyZ66QEklW2marmC1gOWoFHQ53eStOYaFStdk8trDY8kMcVeyqLWW4N9buPtjhF4oxx/wWNRxRrJCbw7CfcHoXRY+CsbGQs5SUvOYP9M3Nnt2TQpYrSqLobgasjiCUSmqNZzcYu2cYwsRaPJm+n0OmgtxCPF8aihVFE80E8HzCY1+oP2D+GMoRJj5dltWceP/t1a+9xvgUNu6uRAqppAD2x3c98gaX1x+7Xc3qo+pJ4nRqlYEvSpeugsNMgAhCmspytdSWcn0A+e5dq1aBtMP3ca6c/gIpY+atLF75SCRCqAQmEPSF3c6nOeQBA6MQenuHdpTa6RaaQDuyKD8M+SQIhZIFTcB9gAn4BUPyIOSDIDRNbMFvUNiIwECOUxf/zcY9kuM1Pxjlt71r3RmDINiavbvRv269AIdgpUDlhY9vkHcgUdKYRDsHdoHJDbUqpx1h7BeNS5JeMWCJuquy3jdmglSiyIOL3nXcP/DSmBKOspMajDGZCBmZCyU9rIcR4TzWOpDj+iuNUdIZePr0qh3YeV4z0erOQazwBfV6E4npjH8z4yDbhHGSGQZOVUChYRfv9JEqlw66ThquDypjV7DCJ5icgTAut3/WhXifbCKwzxdfraeBU8ky7AdPHCGMnrlz10zOuLWFlkrl63xaC8IsTWa9CWtpIrbARKy/D/cohCmKJztjFPeiIZ1ym5nAQJPSnaxgpoFRazVaLiqmkWluU577zsAoSRl7Gpqf2m3pqMWzoUnpaMIoWS1ltpqaEYXJ0mSuG6XH8/IRRvkkxPqLe/31KJJBIRIQRV2nwyIqBGHtFftDgISrQb8BokIomUP1rweu2h4Vwr+cY9f1Hw4tnO43VS44AAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload1);
export default __webpack_public_path__ + "static/media/download 1.b1c00df9efac84efb5eef81a5007d6de.svg";
export { ForwardRef as ReactComponent };